const laPositiva = {
    compañia: 'laPositiva',
    gama: {
        'economico': {
            'La Positiva Medisalud': {
                Dependientes: {
                    26: 2532,
                },
                Titulares: {
                    0: 2532,
                    1: 2532,
                    2: 2532,
                    3: 2532,
                    4: 2532,
                    5: 2532,
                    6: 2532,
                    7: 2532,
                    8: 2532,
                    9: 2532,
                    10: 2532,
                    11: 2532,
                    12: 2532,
                    13: 2532,
                    14: 2532,
                    15: 2532,
                    16: 2532,
                    17: 2532,
                    18: 2748,
                    19: 2976,
                    20: 3264,
                    21: 3468,
                    22: 3756,
                    23: 3876,
                    24: 3972,
                    25: 4080,
                    26: 4260,
                    27: 4512,
                    28: 4716,
                    29: 5052,
                    30: 5340,
                    31: 5472,
                    32: 6060,
                    33: 6300,
                    34: 6672,
                    35: 6768,
                    36: 6828,
                    37: 7260,
                    38: 7392,
                    39: 8760,
                    40: 9312,
                    41: 10128,
                    42: 11220,
                    43: 12348,
                    44: 13512,
                    45: 14268,
                    46: 14820,
                    47: 16248,
                    48: 17028,
                    49: 18144,
                    50: 19152,
                    51: 19152,
                    52: 19152,
                    53: 19152,
                    54: 19152,
                    55: 19152,
                    56: 19152,
                    57: 19152,
                    58: 19152,
                    59: 19152,
                    60: 19152,
                    61: 19152,
                    62: 19152,
                    63: 19152,
                    64: 19152,
                    65: 19152,
                    66: 19152,
                    67: 19152,
                    68: 19152,
                    69: 19152,
                    70: 19152,
                }
            },
        },
        'gamaAlta': {
            'La Positiva Medisalud Plus': {
                Dependientes: {
                    15: 3108,
                    26: 3120
                },
                Titulares: {
                    0: 3108,
                    1: 3108,
                    2: 3108,
                    3: 3108,
                    4: 3108,
                    5: 3108,
                    6: 3108,
                    7: 3108,
                    8: 3108,
                    9: 3108,
                    10: 3108,
                    11: 3108,
                    12: 3108,
                    13: 3108,
                    14: 3108,
                    15: 3108,
                    16: 3120,
                    17: 3120,
                    18: 3804,
                    19: 4296,
                    20: 4644,
                    21: 5640,
                    22: 6132,
                    23: 6612,
                    24: 7248,
                    25: 7656,
                    26: 7836,
                    27: 8532,
                    28: 8928,
                    29: 9372,
                    30: 9480,
                    31: 9840,
                    32: 10848,
                    33: 10908,
                    34: 11580,
                    35: 12024,
                    36: 12144,
                    37: 13560,
                    38: 14268,
                    39: 14544,
                    40: 15444,
                    41: 16224,
                    42: 17364,
                    43: 18564,
                    44: 19920,
                    45: 21420,
                    46: 23436,
                    47: 25572,
                    48: 27756,
                    49: 29328,
                    50: 31356,
                    51: 31356,
                    52: 31356,
                    53: 31356,
                    54: 31356,
                    55: 31356,
                    56: 31356,
                    57: 31356,
                    58: 31356,
                    59: 31356,
                    60: 31356,
                    61: 31356,
                    62: 31356,
                    63: 31356,
                    64: 31356,
                    65: 31356,
                    66: 31356,
                    67: 31356,
                    68: 31356,
                    69: 31356,
                    70: 31356,
                }
            },
        },
        'completo': {
            'La Positiva Premium': {
                Dependientes: {
                    26: 3780
                },
                Titulares: {
                    0: 3780,
                    1: 3780,
                    2: 3780,
                    3: 3780,
                    4: 3780,
                    5: 3780,
                    6: 3780,
                    7: 3780,
                    8: 3780,
                    9: 3780,
                    10: 3780,
                    11: 3780,
                    12: 3780,
                    13: 3780,
                    14: 3780,
                    15: 3780,
                    16: 3780,
                    17: 3780,
                    18: 4428,
                    19: 5256,
                    20: 5832,
                    21: 6120,
                    22: 6624,
                    23: 6852,
                    24: 7044,
                    25: 7572,
                    26: 7968,
                    27: 8268,
                    28: 8484,
                    29: 8796,
                    30: 8796,
                    31: 9540,
                    32: 10248,
                    33: 10836,
                    34: 11052,
                    35: 11160,
                    36: 11832,
                    37: 13404,
                    38: 14160,
                    39: 14940,
                    40: 15528,
                    41: 16320,
                    42: 17256,
                    43: 18432,
                    44: 18660,
                    45: 20256,
                    46: 23172,
                    47: 25488,
                    48: 26976,
                    49: 28620,
                    50: 30744,
                    51: 30744,
                    52: 30744,
                    53: 30744,
                    54: 30744,
                    55: 30744,
                    56: 30744,
                    57: 30744,
                    58: 30744,
                    59: 30744,
                    60: 30744,
                    61: 30744,
                    62: 30744,
                    63: 30744,
                    64: 30744,
                    65: 30744,
                    66: 30744,
                    67: 30744,
                    68: 30744,
                    69: 30744,
                    70: 30744,
                }
            },
        },
        'gamaSuperAlta': {
            'La Positiva Global': {
                Dependientes: {
                    15: 6864,
                    26: 6948
                },
                Titulares: {
                    0: 6864,
                    1: 6864,
                    2: 6864,
                    3: 6864,
                    4: 6864,
                    5: 6864,
                    6: 6864,
                    7: 6864,
                    8: 6864,
                    9: 6864,
                    10: 6864,
                    11: 6864,
                    12: 6864,
                    13: 6864,
                    14: 6864,
                    15: 6864,
                    16: 6948,
                    17: 6948,
                    18: 6948,
                    19: 6948,
                    20: 6948,
                    21: 6948,
                    22: 6948,
                    23: 6948,
                    24: 6948,
                    25: 6948,
                    26: 8820,
                    27: 9948,
                    28: 10824,
                    29: 11292,
                    30: 11364,
                    31: 11508,
                    32: 11652,
                    33: 11712,
                    34: 12180,
                    35: 12648,
                    36: 13044,
                    37: 13524,
                    38: 14244,
                    39: 15072,
                    40: 15708,
                    41: 17160,
                    42: 18084,
                    43: 19344,
                    44: 20496,
                    45: 21588,
                    46: 22188,
                    47: 23016,
                    48: 24396,
                    49: 26244,
                    50: 28272,
                    51: 30420,
                    52: 32472,
                    53: 34944,
                    54: 37680,
                    55: 40620,
                    56: 43776,
                    57: 44016,
                    58: 44364,
                    59: 44364,
                    60: 44364,
                    61: 44364,
                    62: 44364,
                    63: 44364,
                    64: 44364,
                    65: 44364,
                    66: 44364,
                    67: 44364,
                    68: 44364,
                    69: 44364,
                    70: 44364,
                }
            },
        },
    }
}
export default laPositiva